import { Button, Form, Modal } from 'antd';
import { useEffect, useState } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { textOnly } from '../../util/util';

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};

const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: 'none',
    // styles we need to apply on draggables
    ...draggableStyle,
});

export default function MovePart({
    open,
    handelClose,
    scrollAndSetSelectItem,
}) {
    const form = Form.useFormInstance();
    const part = form.getFieldValue('part');
    const { t } = useTranslation();
    const [items, setItems] = useState([]);

    useEffect(() => {
        if (open) setItems(part);
        else setItems([]);
    }, [open, part]);

    const onDragEnd = (result) => {
        const { destination } = result;

        if (!destination) {
            return;
        }

        const reorderedItems = reorder(
            items,
            result.source.index,
            result.destination.index
        );

        setItems(reorderedItems);
        scrollAndSetSelectItem();
    };

    const handleConfirm = () => {
        form.setFieldValue('part', items);
        handleCancel();
    };

    const handleCancel = () => {
        handelClose();
    };

    return (
        <Modal
            width={455}
            className="_modal"
            footer={false}
            open={open}
            onCancel={handleCancel}
            title="ย้ายส่วน"
        >
            <div className="min-h-[500px] h-full">
                <DragDropContext onDragEnd={onDragEnd}>
                    <Droppable droppableId="droppable">
                        {(provided, snapshot) => (
                            <div
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                            >
                                {items.map((item, index) => {
                                    // removes all HTML tags
                                    const _textOnly = item.partName
                                        ? textOnly(item.partName)
                                        : 'ส่วนไม่มีชื่อ';
                                    return (
                                        <Draggable
                                            key={item.id}
                                            draggableId={item.id}
                                            index={index}
                                        >
                                            {(provided, snapshot) => (
                                                <div
                                                    className="bg-[#F4F6FC] p-4 rounded-md mb-2 flex items-center space-x-4"
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                    style={getItemStyle(
                                                        snapshot.isDragging,
                                                        provided.draggableProps
                                                            .style
                                                    )}
                                                >
                                                    {Icon}
                                                    <div>
                                                        <strong
                                                            dangerouslySetInnerHTML={{
                                                                __html: _textOnly,
                                                            }}
                                                        />
                                                        <div>
                                                            ส่วนที่ {index + 1}{' '}
                                                            จาก {part.length}
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </Draggable>
                                    );
                                })}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </DragDropContext>
            </div>
            <div className="flex justify-center items-center space-x-4 pt-4">
                <Button
                    onClick={handleCancel}
                    type="primary"
                    size="large"
                    ghost
                    className="w-36"
                    htmlType="button"
                >
                    {t('common.Cancel')}
                </Button>

                <Button
                    onClick={handleConfirm}
                    size="large"
                    type="primary"
                    className="w-36"
                    htmlType="button"
                >
                    {t('common.Confirm')}
                </Button>
            </div>
        </Modal>
    );
}

const Icon = (
    <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect width={24} height={24} rx={3} fill="#EEE5FF" />
        <g clipPath="url(#clip0_850_20832)">
            <path
                d="M17.3332 10H6.6665V11.3333H17.3332V10ZM6.6665 14H17.3332V12.6667H6.6665V14Z"
                fill="#7B67FB"
            />
        </g>
        <defs>
            <clipPath id="clip0_850_20832">
                <rect
                    width={16}
                    height={16}
                    fill="white"
                    transform="translate(4 4)"
                />
            </clipPath>
        </defs>
    </svg>
);

// validete prop types
MovePart.propTypes = {
    open: PropTypes.bool.isRequired,
    handelClose: PropTypes.func.isRequired,
    scrollAndSetSelectItem: PropTypes.func.isRequired,
};
